import { Divider, Stack } from '@mui/material'

import { ExportAdornment } from '@/components/ExportAdornment'
import { useController } from '../../hooks/useController'
import { OrderData } from './OrderData'
import { FormatPicker } from './FormatPicker'

export function ExportOrders() {
  const {
    data: { format },
  } = useController()

  return (
    <Stack direction="row" height={610}>
      <Stack flex="1 1 auto" gap={4}>
        <OrderData />
        <Divider />
        <FormatPicker />
      </Stack>

      <Stack
        flex="0 0 auto"
        sx={{
          [`& > *`]: {
            height: '100%',
          },
        }}
      >
        <ExportAdornment logo={format} />
      </Stack>
    </Stack>
  )
}
